// routes/config/adminRoutes.ts
/**
 * Admin Route Configuration
 * Routes for admin-only functionality
 */

import { lazy } from 'react';
import { ROUTES } from '../../config/routes';
import type { RouteConfig } from '../types';

const AdminDashboardPage = lazy(() => import('../../features/admin/pages/AdminDashboardPage'));
const AccountsPage = lazy(() => import('../../features/admin/pages/AccountsPage'));
const UserApprovalPage = lazy(() => import('../../features/admin/pages/UserApprovalPage'));
const PlayerAccountsPage = lazy(() => import('../../features/staff/pages/PlayerAccountsPage'));
const RetentionPolicyPage = lazy(() => import('../../features/admin/pages/RetentionPolicyPage'));
const StoreInvitesPage = lazy(() => import('../../features/admin/pages/StoreInvitesPage'));
const StoreManagementPage = lazy(() => import('../../features/admin/pages/StoreManagementPage'));
const AdminFeedbackReportsPage = lazy(() => import('../../features/staff-feedback/pages/AdminFeedbackReportsPage'));
const EventCodesPage = lazy(() => import('../../features/event-codes/pages/EventCodesPage'));

export const adminRoutes: RouteConfig[] = [
  {
    path: ROUTES.ADMIN_DASHBOARD,
    element: AdminDashboardPage,
    auth: 'protected',
    roles: ['admin'],
  },
  {
    path: ROUTES.ACCOUNTS,
    element: AccountsPage,
    auth: 'protected',
    roles: ['admin'],
  },
  {
    path: ROUTES.USER_APPROVAL,
    element: UserApprovalPage,
    auth: 'protected',
    roles: ['admin', 'Manager'],
  },
  {
    path: ROUTES.PLAYER_ACCOUNTS,
    element: PlayerAccountsPage,
    auth: 'protected',
    roles: ['admin'],
  },
  {
    path: ROUTES.RETENTION_POLICY,
    element: RetentionPolicyPage,
    auth: 'protected',
    roles: ['admin'],
  },
  {
    path: ROUTES.STORE_INVITES,
    element: StoreInvitesPage,
    auth: 'protected',
    roles: ['admin'],
  },
  {
    path: ROUTES.STORE_MANAGEMENT,
    element: StoreManagementPage,
    auth: 'protected',
    roles: ['admin'],
  },
  {
    path: ROUTES.FEEDBACK_REPORTS,
    element: AdminFeedbackReportsPage,
    auth: 'protected',
    roles: ['admin'],
  },
  {
    path: ROUTES.EVENT_CODES,
    element: EventCodesPage,
    auth: 'protected',
    roles: ['admin'],
  },
];
